// DataTable.js
// SDS-local trim of V5's common/composites/DataTable: cards below 1024px, table above.
// Sorting, selection and the context menu are left out because SdsRequestsList never uses them.

import React from "react";
import styles from "./DataTable.module.css";

// One card (mobile and tablet)
const DataCard = ({ row, columns, cardActions }) => {
  const cardColumns = columns.filter((col) => col.showInCard && col.type !== "action");

  return (
    <div className={styles.card}>
      <div className={styles.cardContent}>
        {cardColumns.map((col) => {
          const value = col.render ? col.render(row[col.key], row) : row[col.key];
          return (
            <div key={col.key} className={styles.dataRow}>
              <span className={styles.label}>{col.cardLabel || col.label}:</span>
              <span className={styles.value}>{value}</span>
            </div>
          );
        })}
      </div>
      {cardActions && <div className={styles.cardActions}>{cardActions(row)}</div>}
    </div>
  );
};

// One table cell (desktop)
const DataCell = ({ col, row }) => {
  if (col.type === "action") {
    return <td className={styles.deleteColumn}>{col.render ? col.render(row) : null}</td>;
  }

  const value = col.render ? col.render(row[col.key], row) : row[col.key];
  const titleText = typeof value === "string" ? value : row[col.key] || "";

  return <td title={titleText}>{value}</td>;
};

export const DataTable = ({
  data = [],
  columns = [],
  idField = "id",
  cardActions,
  emptyMessage = "No data to display",
}) => {
  if (data.length === 0) {
    return <div className={styles.emptyState}>{emptyMessage}</div>;
  }

  return (
    <div className={styles.tableContainer}>
      <div className={styles.cardContainer}>
        <div className={styles.cardList}>
          {data.map((row) => (
            <DataCard
              key={`card-${row[idField]}`}
              row={row}
              columns={columns}
              cardActions={cardActions}
            />
          ))}
        </div>
      </div>

      <table className={styles.table}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={`row-${row[idField]}`}>
              {columns.map((col) => (
                <DataCell key={col.key} col={col} row={row} />
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
